import React, { useState, useEffect, useCallback, useRef } from "react";
import "./../../App.css";
import "./../Personnel/Employees.css";
import { CreateSearchBarWithPlaceHolder, CreateButton } from "../CommonObjects";
import { CreateTableForEmployeeSelect } from "../ManageTable";
import {
  SetAuditTrail,
  SetAuditTrailBulk,
} from "./../Reports/AuditTrailReportEmployeeSetup";
import axios from "axios";
import { token, domain } from "../Security";
import loadingSpinner from "./../../assets/loading.gif";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { useTable, useSortBy } from "react-table";
// icons
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import PreviewIcon from "@mui/icons-material/Preview";

function EmployeeDailySalary({ user, isHideSideMenu }) {
  var headerShowAccess = [
    "Employee Id",
    "Employee",
    "Daily Salary",
    "Allowance",
    "",
  ];
  var accessorShowAccess = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "salary",
    "allowance",
    "manage",
  ];
  var header = ["Employee Id", "Employee", "Daily Salary", "Allowance"];
  var accessor = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "salary",
    "allowance",
  ];
  const [currentPage, setCurrentPage] = useState(1);

  const [showSetting, setShowSetting] = useState(false);
  const settingRef = useRef(null);
  const buttonRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
  const [employeeDailySalary, setEployeeDailySalary] = useState([]);
  const [showUploadForm, setShowUploadForm] = useState(false);

  const [showAuthentication, setShowAuthentication] = useState(false);
  const [showAccess, setShowAccess] = useState(false);
  const [isView, setIsView] = useState(false);
  const [isViewAll, setIsViewAll] = useState(false);

  // Retrieve
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] =
    useState("Search by employee");

  const [selectedData, setSelectedData] = useState(null);
  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const addHandleClick = (data) => {
    setShowAddForm(true);
  };
  const closeAddHandleClick = () => {
    setShowAddForm(false);
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };
  // Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [employeePersonalInformationId, setEmployeePersonalInformationId] =
    useState("");
  const [
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
  ] = useState("");
  const [salary, setSalary] = useState("");
  const [allowance, setAllowance] = useState("");
  //old
  const [oldSalary, setOldSalary] = useState("");
  const [oldAllowance, setOldAllowance] = useState("");
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const apiUrl = domain + "/api/EmployeeDailySalary";

  const fetchDataForEmployee = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/single-data";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      setEployeeDailySalary(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by employee");
        break;
      case 1:
        setSearchPlaceholder("Search by employee id");
        break;
      default:
        setSearchPlaceholder("Search by employee");
        break;
    }
  }, [filterDataIndex, fetchData]);

  const handleFilter = (value) => {
    setCurrentPage(1);

    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.employeePersonalInformationFullName
            .toLowerCase()
            .includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeePersonalInformationId.toString().includes(lowercaseValue)
        );
        break;
      default:
        break;
    }

    setEployeeDailySalary(res);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      salary: salary,
      allowance: allowance,
    };

    try {
      setLoadingRequest(true);
      await axios.post(apiUrl, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let auditInfo = [];

      auditInfo.push({
        setupArea: "Employee Daily Salary",
        actionTaken: "add",
        field: "Allowance",
        newValue: ``,
        oldValue: ``,
        dateSaved: new Date(),
        savedById: user.id,
      });

      setShowAddForm(false); // Hide the add form
      await SetAuditTrailBulk({ data: auditInfo });
      await createHistory(data);
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setSalary("");
      setAllowance("");
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setEmployeePersonalInformationId("");
    setSalary("");
    setAllowance("");
    setShowAddForm(false);
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      salary: salary,
      allowance: allowance,
    };

    try {
      setLoadingRequest(true);
      await axios.put(`${apiUrl}/${selectedData.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      let auditInfo = [];

      if (data.salary !== oldSalary) {
        auditInfo.push({
          setupArea: "Employee Daily Salary",
          actionTaken: "update",
          field: "Salary",
          newValue: `${data.salary}`,
          oldValue: `${oldSalary}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.allowance !== oldAllowance) {
        auditInfo.push({
          setupArea: "Employee Daily Salary",
          actionTaken: "update",
          field: "Allowance",
          newValue: `${data.allowance}`,
          oldValue: `${oldAllowance}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      setShowEditForm(false); // Hide the add form
      await SetAuditTrailBulk({ data: auditInfo });
      await createHistory(data);
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log("Data added successfully");
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setSalary("");
      setAllowance("");
    } catch (error) {
      console.error("There was a problem adding data:", error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setEmployeePersonalInformationId("");
    setSalary("");
    setAllowance("");
    setShowEditForm(false);
  };

  const createHistory = async (_data) => {
    const data = {
      employeePersonalInformationId: _data.employeePersonalInformationId,
      actionType: "Add",
      salary: _data.salary,
      allowance: _data.allowance,
      isApproved: false,
      createdDate: new Date(),
      createdById: user.id,
    };

    const apiUrlHistory = domain + "/api/DailySalaryHistory";

    try {
      await axios.post(apiUrlHistory, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Data added successfully");
    } catch (error) {
      console.error("There was a problem adding data:", error);
    }
  };
  const createHistoryBulk = async (bulkData) => {
    const apiUrlHistory = domain + "/api/DailySalaryHistory/bulk";

    const data = bulkData.map((item) => ({
      employeePersonalInformationId: item.employeePersonalInformationId,
      actionType: "Add",
      salary: item.salary,
      allowance: item.allowance,
      isApproved: false,
      createdDate: new Date(),
      createdById: user.id,
    }));

    try {
      await axios.post(apiUrlHistory, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Data added successfully");
    } catch (error) {
      console.error("There was a problem adding data:", error);
    }
  };

  const handleSubmitView = async () => {
    setIsView(true);
  };
  const handleSubmitViewAll = () => {
    setIsViewAll(true);
  };
  const handleSubmitHideAll = () => {
    setIsViewAll(false);
  };
  const handleShowAccess = () => {
    // setShowAccess(true);
    setShowAuthentication(true);
  };
  const handleAuthenticationSubmit = async () => {
    setShowAccess(true);
    setShowAuthentication(false);
  };
  const closeAuthenticationHandleClick = () => {
    setShowAuthentication(false);
  };
  const generateDownloadTemplate = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("EmployeeDailySalary");

    const header = ["EmployeeId", "EmployeeName", "Salary", "Allowance"];
    const headerRow = worksheet1.addRow(header);
    worksheet1.columns = [
      { key: "employeeId", width: 30 },
      { key: "employeeName", width: 30 },
      { key: "salary", width: 30 },
      { key: "allowance", width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    employeeDailySalary.forEach((salary, index) => {
      const information = [
        {
          employeeId: salary.employeePersonalInformationEmployeeId,
          employeeName: salary.employeePersonalInformationFullName,
          salary: salary.salary,
          allowance: salary.allowance,
        },
      ];

      information.forEach((info) => {
        worksheet1.addRow(info);
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Employee_Daily_Salary_Template.xlsx");
  }, [employeeDailySalary]);
  const generateDownloadRecords = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet("EmployeeDailySalary");

    const header = ["EmployeeId", "EmployeeName", "Salary", "Allowance"];
    const headerRow = worksheet1.addRow(header);
    worksheet1.columns = [
      { key: "employeeId", width: 30 },
      { key: "employeeName", width: 30 },
      { key: "salary", width: 30 },
      { key: "allowance", width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "92d050" },
      };
    });

    employeeDailySalary.forEach((info) => {
      worksheet1.addRow([
        info.employeePersonalInformationEmployeeId,
        info.employeePersonalInformationFullName,
        info.salary.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        info.allowance.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
      ]);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Employee_Daily_Salary_Records.xlsx");
  }, [employeeDailySalary]);

  const [uploadData, setUploadData] = useState([]);
  const uploadEmployeeData = async (file) => {
    setLoadingUploadRequest(true);
    const dataEmployee = await fetchDataForEmployee();

    function sanitizeValue(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return "";
      }
      return value;
    }
    function sanitizeValueInteger(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        (typeof value === "string" &&
          value.startsWith("<") &&
          value.endsWith(">"))
      ) {
        return 0;
      }
      return value;
    }
    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeeId) missing.push("Employee Id");

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = dataEmployee.find(
          (employee) => employee.employeeId === item.employeeId?.toString()
        );
        if (!existingEmployee) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Employee Id does not exist.`
              : `Employee Id does not exist. `;
        }

        if (!Number.isFinite(item.salary)) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Invalid value - Salary.`
              : `Invalid value - Salary. `;
        }

        if (!Number.isFinite(item.allowance)) {
          errorMessage +=
            errorMessage.length > 0
              ? ` Invalid value - Allowance.`
              : `Invalid value - Allowance. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(", ")}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      };

      const informations = parseWorksheet(
        workbook.Sheets[workbook.SheetNames[0]]
      );

      let bulkData = [];

      informations.forEach((info) => {
        let foundEmployee = null;

        foundEmployee = dataEmployee.find(
          (data) =>
            data.employeeId.toLowerCase() ===
            sanitizeValue(info.EmployeeId).toString().toLowerCase()
        );

        // i will use the locations, employments etc. here below
        bulkData.push({
          employeeId: sanitizeValue(info.EmployeeId),
          fullName: sanitizeValue(info.EmployeeName),
          employeePersonalInformationId: foundEmployee
            ? sanitizeValue(foundEmployee.id)
            : 0,
          salary: info.Salary ? sanitizeValueInteger(info.Salary) : 0,
          allowance: info.Allowance ? sanitizeValueInteger(info.Allowance) : 0,
        });
      });

      // Validate the bulk data
      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadData(sortedData);

      /* if (!validation.isValid) {
                setLoadingRequest(false);
                setShowRequestMessage(true);
                setIsSuccess(false);
                setRequestMessage(validation.message.split('\n').map((line, index) => (
                    <div key={index}>{line}</div>
                )));
                return;
            }

            const apiUrl = `${domain}/api/EmployeeDailySalary/bulk`;
        
            try {
                await axios.post(apiUrl, bulkData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });
                await SetAuditTrail({
                    setupArea: "Employee Daily Salary", 
                    actionTaken: "upload", 
                    field: "Upload", 
                    newValue: `-`, 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });
                await createHistoryBulk(bulkData)
                await fetchData(); // Assuming fetchData() fetches the updated data for the table

                setShowRequestMessage(true);
                setIsSuccess(true);
            } catch (error) {
                setShowRequestMessage(true);
                setIsSuccess(false);
                console.error('Error:', error);
                const errorMessage = JSON.parse(error.response.request.responseText).message;
                setRequestMessage(errorMessage);
            }
            
            setLoadingRequest(false); */
    };

    setLoadingUploadRequest(false);
    reader.readAsArrayBuffer(file);
  };
  function handleFileUpload(files) {
    if (!files || files.length === 0) {
      console.error("No files selected");
      return;
    }

    const file = files[0];
    uploadEmployeeData(file);
  }
  const handleFinalFileUpload = async (bulkData) => {
    setLoadingRequest(true);

    const apiUrl = `${domain}/api/EmployeeDailySalary/bulk`;

    try {
      await axios.post(apiUrl, bulkData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      await SetAuditTrail({
        setupArea: "Employee Daily Salary",
        actionTaken: "upload",
        field: "Upload",
        newValue: `-`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id,
      });
      await createHistoryBulk(bulkData);
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleSetting = () => {
    setShowSetting(!showSetting);
  };

  useEffect(() => {
    var settingIcon = document.getElementById("setting-icon");

    if (showSetting) {
      //change the down icon to up
      settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
      settingIcon.children[0].setAttribute(
        "d",
        `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`
      ); // Up Arrow.Path d attribute
    } else {
      //change the up icon to down
      settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
      settingIcon.children[0].setAttribute(
        "d",
        `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`
      ); // Down Arrow.Path d attribute
    }

    const handleClickOutside = (event) => {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetting(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSetting]);

  const editHandleClick = (data) => {
    setSelectedData(data);
    setShowEditForm(true);
    setEmployeePersonalInformationFullName(
      data.employeePersonalInformationFullName
    );
    setEmployeePersonalInformationId(data.employeePersonalInformationId);
    setSalary(data.salary);
    setAllowance(data.allowance);
    setOldSalary(data.salary);
    setOldAllowance(data.allowance);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };
  const openUploadFormHandleClick = () => {
    setShowUploadForm(true);
  };
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  };

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [historyData, setHistoryData] = useState([]);

  const openHistory = (data) => {
    setHistoryData(data);
    setShowViewHistory(true);
  };

  const closeHistory = () => {
    setShowViewHistory(false);
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Salary Module >"}{" "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Employee Daily Salary"}
                </span>
              </div>
              <div
                className="row"
                style={{
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3>Employee Daily Salary</h3>
                <div
                  style={{
                    width: "30%",
                    textAlign: "right",
                    display: showAccess ? "block" : "none",
                  }}
                >
                  <button
                    ref={buttonRef}
                    onClick={handleSetting}
                    title="Setting"
                    type="button"
                    className="setting"
                  >
                    <SettingsIcon />
                    <KeyboardArrowDownIcon id="setting-icon" />
                  </button>
                  <div ref={settingRef}>
                    {showSetting && (
                      <SettingInit
                        generateDownloadTemplate={generateDownloadTemplate}
                        openUploadFormHandleClick={openUploadFormHandleClick}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="employeesTab-body">
              {Filter(setFilterDataIndex)}
              <div className="body-top row">
                <div className="body-top-search">
                  {CreateSearchBarWithPlaceHolder(
                    "",
                    "mainte-search row",
                    "mainte-search-icon",
                    "mainte-search-input",
                    (e) => handleFilter(e.target.value),
                    searchPlaceholder,
                    SearchIcon
                  )}
                </div>
                <div
                  className="body-top-btn row"
                  style={{ justifyContent: "end" }}
                >
                  {showAccess && (
                    <>
                      <div style={{ display: "none" }}>
                        {CreateButton(
                          "",
                          "add row",
                          addHandleClick,
                          "ADD",
                          NoteAddIcon
                        )}
                      </div>
                      {CreateButton(
                        "",
                        "view-all row",
                        generateDownloadRecords,
                        "EXTRACT",
                        DownloadIcon
                      )}
                    </>
                  )}
                  {showAccess
                    ? isViewAll
                      ? CreateButton(
                          "",
                          "hide row",
                          () => handleSubmitHideAll(),
                          "HIDE ALL",
                          VisibilityOffIcon
                        )
                      : CreateButton(
                          "",
                          "showAccess row",
                          () => handleSubmitViewAll(),
                          "VIEW ALL",
                          RemoveRedEyeIcon
                        )
                    : CreateButton(
                        "",
                        "showAccess row",
                        () => handleShowAccess(),
                        "SHOW ACCESS",
                        LockOpenIcon
                      )}
                </div>
              </div>
              <div className="employeesTab-table container">
                <CreateTable
                  dataList={employeeDailySalary}
                  dataHeader={showAccess ? headerShowAccess : header}
                  dataAccessor={showAccess ? accessorShowAccess : accessor}
                  tableType="Employees Tab"
                  editHandleClick={editHandleClick}
                  viewRequest={handleSubmitView}
                  openHistory={openHistory}
                  isViewAll={isViewAll}
                  isView={isView}
                  setIsView={setIsView}
                  showAccess={showAccess}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        salary={salary}
        allowance={allowance}
        setSalary={setSalary}
        setAllowance={setAllowance}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setEmployeePersonalInformationFullName={
          setEmployeePersonalInformationFullName
        }
        setShowEmployeeForm={setShowEmployeeForm}
        handleSubmit={handleSubmit}
      ></AddForm>
      <EditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationFullName={
          employeePersonalInformationFullName
        }
        employeePersonalInformationId={employeePersonalInformationId}
        salary={salary}
        allowance={allowance}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setSalary={setSalary}
        setAllowance={setAllowance}
        handleSubmit={handleUpdate}
      ></EditForm>
      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationId}
        setEmployee={setEmployeePersonalInformationFullName}
      ></EmployeeSelectForm>
      <UploadForm
        isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        data_temp={uploadData}
        setData_temp={setUploadData}
        handleFileUpload={handleFileUpload}
        handleFinalFileUpload={handleFinalFileUpload}
      ></UploadForm>
      <Authentication
        isOpen={showAuthentication}
        onClose={closeAuthenticationHandleClick}
        user={user}
        handleSubmit={handleAuthenticationSubmit}
      ></Authentication>
      <ViewHistoryForm
        isOpen={showViewHistory}
        onClose={closeHistory}
        employeePersonalInformationId={
          historyData.employeePersonalInformationId
        }
      />
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
      {loadingUploadRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function AddForm({
  isOpen,
  onClose,
  employeePersonalInformationId,
  employeePersonalInformationFullName,
  salary,
  allowance,
  setEmployeePersonalInformationId,
  setEmployeePersonalInformationFullName,
  setSalary,
  setAllowance,
  setShowEmployeeForm,
  handleSubmit,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!employeePersonalInformationId || !salary || !allowance) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEmployeePersonalInformationId("");
    setEmployeePersonalInformationFullName("");
    setSalary("");
    setAllowance("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Add Daily Salary</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <div
                    className="info-item-holder employee-select row"
                    style={{ flexDirection: "row", justifyContent: "normal" }}
                  >
                    <input
                      readOnly
                      className="employeeInput-select"
                      placeholder="Employee"
                      value={
                        employeePersonalInformationId
                          ? employeePersonalInformationFullName
                          : employeePersonalInformationId
                      }
                    />
                    <button
                      className="select row"
                      onClick={() => setShowEmployeeForm(true)}
                    >
                      <SearchIcon />
                    </button>
                  </div>
                  <span
                    style={{
                      visibility:
                        !employeePersonalInformationId && errorState
                          ? "visible"
                          : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                  {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Salary</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    id="salary"
                    placeholder="Salary"
                    value={salary}
                    onChange={(e) => setSalary(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !salary && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Allowance</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    id="allowance"
                    placeholder="Allowance"
                    value={allowance}
                    onChange={(e) => setAllowance(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !allowance && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EditForm({
  isOpen,
  onClose,
  employeePersonalInformationFullName,
  employeePersonalInformationId,
  salary,
  allowance,
  setEmployeePersonalInformationId,
  setSalary,
  setAllowance,
  handleSubmit,
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (
      employeePersonalInformationId === "" ||
      salary === "" ||
      allowance === ""
    ) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setEmployeePersonalInformationId("");
    setSalary("");
    setAllowance("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Daily Salary</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee Id</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    id="employeePersonalInformationId"
                    placeholder="Employee Id"
                    value={`${employeePersonalInformationFullName}`}
                    onChange={(e) =>
                      setEmployeePersonalInformationId(e.target.value)
                    }
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
                <span
                  style={{
                    visibility: "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Salary</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    id="salary"
                    placeholder="Salary"
                    value={salary}
                    onChange={(e) => setSalary(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      salary === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Allowance</div>
                <div className="info-item-input">
                  <input
                    type="number"
                    id="allowance"
                    placeholder="Allowance"
                    value={allowance}
                    onChange={(e) => setAllowance(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility:
                      allowance === "" && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function Filter(setFilterDataIndex) {
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function Authentication({ isOpen, onClose, user, handleSubmit }) {
  const [errorState, setErrorState] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  // const [loading, setLoading] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const submit = async (e) => {
    if (!username || !password) {
      setErrorState(true);
      return;
    }

    if (username !== "admin" || password !== "qkEcJETL") {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Invalid username or password");
      return;
    }

    /* const isAuthorize = await checkUser(e);

        if(!isAuthorize){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("Invalid username or password");
            return;
        } */

    handleSubmit();
    setErrorState(false);
  };

  /* const checkUser = async (event) => {
        event.preventDefault();

        const data = {
            userName: username,
            password: password
        };

        const apiUrlFetch = domain + "/api/Authentication/login";

        try {
            setLoading(true);
            const response = await axios.post(apiUrlFetch, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if(response.data.employeePersonalInformationId === user.employeePersonalInformationId){
                return true;
            } else {
                return false;
            }
        } catch (error) {
            setLoading(false);
            return false;
        } finally {
            setLoading(false);
        }
    }; */

  const handleClose = () => {
    onClose();
    setUsername("");
    setPassword("");
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Authentication</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Username</div>
                <div className="info-item-input">
                  <input
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !username && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Password</div>
                <div className="info-item-input">
                  <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <span
                  style={{
                    visibility: !password && errorState ? "visible" : "hidden",
                    color: "#ff6565",
                    fontSize: "12px",
                  }}
                >
                  Please fill up this field
                </span>
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "20px 40px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={(e) => submit(e)}
              >
                ENTER
              </button>
            </div>
          </div>
        )}
      </div>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {/* {loading ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
    </>
  );
}
function SettingInit({ generateDownloadTemplate, openUploadFormHandleClick }) {
  return (
    <div id="payroll-setting" className="payroll-setting column">
      <div
        className="payroll-setting-item row"
        onClick={() => generateDownloadTemplate(false)}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}>
          <DownloadIcon />
        </div>
        Download Template
      </div>
      <div
        className="payroll-setting-item row"
        onClick={() => openUploadFormHandleClick()}
      >
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}>
          <FileUploadIcon />
        </div>
        Upload Daily Salary
      </div>
    </div>
  );
}
function UploadForm({
  isOpen,
  onClose,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload,
}) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter((i) => i.errors.length > 0);

      if (_errorData.length <= 0) {
        setHasNoError(true);
      } else {
        setHasNoError(false);
      }
    }
  }, [data_temp]);

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files);
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles]);

  const submit = (e) => {
    handleFinalFileUpload(data_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = ["Employee Id", "Employee Name", "Salary", "Allowance", "Error"];
  var accessor = ["employeeId", "fullName", "salary", "allowance", "errors"];

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Salary"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div
              className="popUp-body user-template-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>

            <div>
              <label htmlFor="fileInput" className="browse">
                Browse...
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: "none" }}
              />
              <div
                id="drop-files-here"
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "5px",
                  padding: "20px",
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div
                    className="buttons row"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{
                        marginRight: "5px",
                        height: "34px",
                        borderRadius: "3px",
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ? (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#4cc92a",
                        color: "white",
                      }}
                    >
                      Data is valid.
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "10px",
                        backgroundColor: "#ce3434",
                        color: "white",
                      }}
                    >
                      Cannot upload with error.
                    </div>
                  </>
                )}
                <div
                  className="employeesTab-tab upload-preview-tab"
                  style={{ marginTop: "10px" }}
                >
                  <div
                    id="container1 table-uploads"
                    className="employeesTab-table container"
                  >
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div
                  className="buttons row"
                  style={{
                    justifyContent: "end",
                    padding: "40px 40px 20px 40px",
                  }}
                >
                  {hasNoError && (
                    <button
                      id="add-family"
                      className="save row"
                      onClick={(e) => submit(e)}
                      style={{ marginRight: "5px" }}
                    >
                      UPLOAD
                    </button>
                  )}
                  <button
                    id="add-family"
                    className="cancel row"
                    style={{
                      marginRight: "5px",
                      height: "34px",
                      borderRadius: "3px",
                    }}
                    onClick={() => handleClose()}
                  >
                    CANCEL
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
export function CreateTable({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  viewRequest,
  openHistory,
  isViewAll,
  isView,
  setIsView,
  deleteHandleClick,
  showAccess,
  currentPage,
  setCurrentPage,
}) {
  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [viewCell, setViewCell] = useState(null);

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleViewRequest = (cellKey) => {
    setViewCell(cellKey);
    viewRequest(false); // Or whatever logic you need to handle the view request
    setIsView(true);
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <SetInfo
                    header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                    editHandleClick={editHandleClick}
                    viewRequest={() =>
                      handleViewRequest(cell.getCellProps().key)
                    }
                    openHistory={openHistory}
                    isViewAll={isViewAll}
                    isView={viewCell === cell.getCellProps().key}
                    setIsView={setIsView}
                    showAccess={showAccess}
                  />
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfo({
  header,
  _cell,
  editHandleClick,
  viewRequest,
  openHistory,
  isViewAll,
  isView,
  setIsView,
  showAccess,
  deleteHandleClick,
}) {
  const data = _cell.render("Cell").props.row.original;

  const [isExpandedCell, setIsExpandedCell] = useState(null);

  const handleCellClick = () => {
    if (isExpandedCell === _cell.getCellProps().key) {
      setIsExpandedCell(null); // Collapse the current cell if clicked again
    } else {
      setIsExpandedCell(_cell.getCellProps().key); // Expand the clicked cell
      viewRequest(_cell.getCellProps().key); // Pass the cell key to handle the view request
    }
  };

  //Double type data
  if (header === "Daily Salary" || header === "Allowance") {
    const value = _cell.render("Cell").props.value;
    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}>{_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    if (isViewAll) {
      return (
        <td>
          <div
            className="row"
            style={{ alignItems: "center", justifyContent: "center" }}
          >
            {formattedNumber}
            <Tooltip text="Hide">
              <div
                className="history"
                style={{ padding: "0 5px", marginRight: "5px" }}
                onClick={handleCellClick}
              >
                <VisibilityOffIcon />
              </div>
            </Tooltip>
          </div>
        </td>
      );
    }

    if (isExpandedCell === _cell.getCellProps().key) {
      return (
        <td>
          <div
            className="row"
            style={{ alignItems: "center", justifyContent: "center" }}
          >
            {formattedNumber}
            <Tooltip text="Hide">
              <div
                className="history"
                style={{ padding: "0 5px", marginRight: "5px" }}
                onClick={handleCellClick}
              >
                <VisibilityOffIcon />
              </div>
            </Tooltip>
          </div>
        </td>
      );
    }

    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          *****
          {showAccess ? (
            <Tooltip text="View">
              <div
                className="history"
                style={{ padding: "0 5px", marginRight: "5px" }}
                onClick={handleCellClick}
              >
                <RemoveRedEyeIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          <Tooltip text="View">
            <div style={{ padding: "0 5px" }} onClick={() => openHistory(data)}>
              <PreviewIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "70%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
function EmployeeSelectForm({ isOpen, onClose, setEmployeeId, setEmployee }) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const inHouseClassification = 2;

  const fetchData = async () => {
    const apiUrl =
      domain +
      `/api/Employee/basic-info/all/active/classification/${inHouseClassification}`;

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });

      console.log({Data:response.data});

      setEmployees(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  };
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function ViewHistoryForm({ isOpen, onClose, employeePersonalInformationId }) {
  var header = [
    "ActionType",
    "Salary",
    "Allowance",
    // "Is Approved?",
    "Created Date",
    "Created By",
  ];
  var accessor = [
    "actionType",
    "salary",
    "allowance",
    // "isApproved",
    "createdDate",
    "createdBy",
  ];

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/DailySalaryHistory";

    try {
      setLoading(true);
      const response = await axios.get(
        `${apiUrl}/employee/${employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      setData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [employeePersonalInformationId]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen]);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>History</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div
                className="users-table container"
                style={{ overflow: "unset" }}
              >
                <CreateTableHistory
                  dataList={data ? data : []}
                  dataHeader={header}
                  dataAccessor={accessor}
                />
                {data.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            ></div>
          </div>
        )}
      </div>
    </>
  );
}
export function CreateTableHistory({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  deleteHandleClick,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfoHistory(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
function SetInfoHistory(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Uploaded Image") {
    if (data.content) {
      const imageSrc = "data:image/jpeg;base64," + data.content;

      return (
        <td>
          <img
            className=""
            src={imageSrc}
            alt=""
            style={{ width: "250px", height: "auto" }}
          />
        </td>
      );
    }
    return (
      <td>
        <img className="" src="" alt="" />
      </td>
    );
  }

  if (header === "Reference No.") {
    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Is Approved?") {
    return <td>{data.isApproved ? "Approved" : "Pending"}</td>;
  }

  if (header === "Has Allowance" || header === "Is Above 2 Hours") {
    return <td>{value.toString()}</td>;
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Request Date" ||
    header === "Date Requested" ||
    header === "Created Date"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  //Double type data
  if (
    header === "Over Percentage" ||
    header === "Deduction" ||
    header === "Salary" ||
    header === "Employee" ||
    header === "Employer" ||
    header === "Range From" ||
    header === "Range To" ||
    header === "Monthly Salary" ||
    header === "SSS ER" ||
    header === "SSS EE" ||
    header === "SSS Total" ||
    header === "ECER" ||
    header === "Total Contribution ER" ||
    header === "Total Contribution EE" ||
    header === "Total Contribution Total" ||
    header === "SE Total Contribution" ||
    header === "Salary Range From" ||
    header === "Salary Range To" ||
    header === "Total Monthly Premium" ||
    header === "Percentage" ||
    header === "Amount" ||
    header === "Total Loan" ||
    header === "Total Balance" ||
    header === "Default Deduction" ||
    header === "Allowance" ||
    header === "Daily Salary" ||
    header === "Allowance" ||
    header === "Total Basic" ||
    header === "Rate" ||
    header === "Hours OT Regular" ||
    header === "Total OT Regular" ||
    header === "Hours OT Exceeded" ||
    header === "Total OT Exceeded" ||
    header === "Hours OT Restday" ||
    header === "Total OT Restday" ||
    header === "Hours Holiday Special" ||
    header === "Total Holiday Special" ||
    header === "Hours Holiday Regular" ||
    header === "Total Holiday Regular" ||
    header === "Hours Restday Holiday Special" ||
    header === "Total Restday Holiday Special" ||
    header === "Hours Restday Holiday Regular" ||
    header === "Total Restday Holiday Regular" ||
    header === "Additions" ||
    header === "SSS" ||
    header === "Pagibig" ||
    header === "Philhealth" ||
    header === "SSS Loan" ||
    header === "SSS Calamity Loan" ||
    header === "Pagibig Loan" ||
    header === "Pagibig Calamity Loan" ||
    header === "Tax" ||
    header === "Deductions" ||
    header === "Adjustments" ||
    header === "Total Net Pay" ||
    header === "Days Absent" ||
    header === "Absent/s" ||
    header === "Days Leave" ||
    header === "Leave/s" ||
    header === "Hours Exceeded" ||
    header === "Total Exceeded" ||
    header === "Hours Undertime" ||
    header === "Undertime" ||
    header === "Hours Late" ||
    header === "Late" ||
    header === "Night Diff" ||
    header === "OT Regular" ||
    header === "OT Restday" ||
    header === "Holiday Special" ||
    header === "Holiday Regular" ||
    header === "Restday Holiday Special" ||
    header === "Restday Holiday Regular" ||
    header === "Total Absents" ||
    header === "Total Late" ||
    header === "Total Undertime" ||
    header === "Total Leaves" ||
    header === "Total Night Diff" ||
    header === "Total Exceed" ||
    header === "Exceed"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
function CreateTableForUpload({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage,
  setCurrentPage,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({
    id: "",
    desc: false,
    isDefault: true,
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy,
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? [] // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }], // Apply sorting if not default
      },
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" },
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${
                    sortHeaderValue.id === column.id
                      ? sortState[
                          sortHeaderValue.isDefault
                            ? 0
                            : sortHeaderValue.desc
                            ? 2
                            : 1
                        ].textValue
                      : ""
                  }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr
                key={row.original.id}
                {...row.getRowProps()}
                className={row.original.error ? "error" : ""}
              >
                {row.cells.map((cell) => (
                  <SetInfoForUpload
                    header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                  />
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "25px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "25px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "25px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "25px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function SetInfoForUpload({ header, _cell }) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (data.photo) {
      const imageSrc = "data:image/jpeg;base64," + data.photo;

      return (
        <td>
          <img className="avatarImg" src={imageSrc} alt="" />
        </td>
      );
    }
    return (
      <td>
        <img className="avatarImg" src="images/sample.jpg" alt="" />
      </td>
    );
  }

  if (header === "Date Created") {
    if (!value) {
      return <td></td>;
    }

    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  if (header === "Error") {
    return (
      <td>{value && <p style={{ color: "red", margin: 0 }}>{value}</p>}</td>
    );
  }

  if (
    header === "Vacation Leave" ||
    header === "Sick Leave" ||
    header === "Service Incentive Leave" ||
    header === "Solo Parent Leave" ||
    header === "Vacation Leave Remaining" ||
    header === "Sick Leave Remaining" ||
    header === "Service Incentive Leave Remaining" ||
    header === "Solo Parent Leave Remaining"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}

export default EmployeeDailySalary;
